// paymentActions.js
import {
  FETCH_FEE_PAYMENT_REQUEST,
  FETCH_FEE_PAYMENT_SUCCESS,
  FETCH_FEE_PAYMENT_FAILURE,
} from './FeeActionTypes';
import axios from '../../interceptor/axios-config';
import config from '../../config';

// Action creators
export const fetchFeePaymentRequest = () => ({
    type: FETCH_FEE_PAYMENT_REQUEST,
  });
  
  export const fetchFeePaymentSuccess = (payments) => ({
    type: FETCH_FEE_PAYMENT_SUCCESS,
    payload: payments,
  });
  
  export const fetchFeePaymentFailure = (error) => ({
    type: FETCH_FEE_PAYMENT_FAILURE,
    payload: error,
  });
  
  // Thunk action to fetch all fee payment data
  export const fetchFeePaymentData = () => {
    return async (dispatch) => {
      dispatch(fetchFeePaymentRequest());
  
      try {
        // Use GET request to fetch all data
        const response = await axios.get(`${config.apiBaseUrl}/payments/getBalances.php`);
        const payments = response.data;
        dispatch(fetchFeePaymentSuccess(payments));
      } catch (error) {
        dispatch(fetchFeePaymentFailure(error.message));
      }
    };
  };
